import React from 'react';
import { remoteManagementRoute } from '@/modules/remote-management/route';
import { createRoute } from '@tanstack/react-router';

export const remoteManagementDetailsRoute = createRoute({
  getParentRoute: () => remoteManagementRoute,
  path: 'grid-connections/$gridConnectionId',
  component: React.lazy(async () => await import('@/app/routes/RemoteManagement/Details')),
  wrapInSuspense: true,
});
